import React, { useEffect, useState, useRef } from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { Container, Card, CardContent, Typography, Box, Alert, CircularProgress, Link } from '@mui/material';
import axios from 'axios';
import { APP_DISPLAY_NAME } from '../constants/branding';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    if (!token) {
      setStatus('error');
      setMessage('Missing verification token. Open the link from your email, or request a new one from the sign-in page.');
      return;
    }

    (async () => {
      try {
        const isLocalhost =
          typeof window !== 'undefined' &&
          (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
        if (isLocalhost && !axios.defaults.baseURL) {
          axios.defaults.baseURL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
        }
        const res = await axios.post('/api/auth/verify-email', { token });
        setStatus('ok');
        setMessage(res.data?.message || 'Your email is verified. You can sign in.');
      } catch (err) {
        setStatus('error');
        setMessage(
          err.response?.data?.message ||
            err.response?.data?.error ||
            'Verification failed. The link may have expired.'
        );
      }
    })();
  }, [token]);

  return (
    <Container component="main" maxWidth="sm">
      <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Card elevation={3} sx={{ width: '100%' }}>
          <CardContent sx={{ py: 4, px: 3 }}>
            <Typography
              component="h1"
              variant="h4"
              gutterBottom
              sx={{
                fontWeight: 700,
                letterSpacing: '0.28em',
                color: 'primary.dark',
                fontSize: { xs: '1.5rem', sm: '1.75rem' }
              }}
            >
              {APP_DISPLAY_NAME}
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
              Email verification
            </Typography>

            {status === 'loading' && (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                <CircularProgress />
              </Box>
            )}
            {status === 'ok' && <Alert severity="success">{message}</Alert>}
            {status === 'error' && <Alert severity="error">{message}</Alert>}

            <Typography variant="body2" sx={{ mt: 3 }}>
              <Link component={RouterLink} to="/login">
                Go to sign in
              </Link>
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default VerifyEmail;
